import type { FC } from "react";

export const ProfileIcon: FC = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C13.9288 21 15.6795 20.0952 17 18.6055C16.9258 17.7464 16.4807 16.9056 15.6869 16.2475C13.6691 14.5842 10.3457 14.5842 8.31305 16.2475C7.51929 16.9056 7.07418 17.7464 7 18.6055C8.32047 20.0952 10.0712 21 12 21ZM12 21C16.9705 21 21 16.9705 21 12C21 7.02944 16.9705 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9705 7.02945 21 12 21ZM12.1098 13C12.0457 12.9908 11.9634 12.9908 11.8902 13C10.2805 12.945 9 11.626 9 10.0046C9 8.34656 10.3354 7 12 7C13.6555 7 15 8.34656 15 10.0046C14.9909 11.626 13.7195 12.945 12.1098 13Z"
        stroke="#A10F04"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
